import { render, staticRenderFns } from "./CreateTopicsModal.vue?vue&type=template&id=5bc16153&scoped=true&"
import script from "./CreateTopicsModal.vue?vue&type=script&lang=js&"
export * from "./CreateTopicsModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateTopicsModal.vue?vue&type=style&index=0&id=5bc16153&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc16153",
  null
  
)

export default component.exports